import { UserPermission } from '../../permission/enum';

export const userRoutes = [
    {
        path: '/user',
        name: 'Users',
        exact: true,
        component: () => import('../views/UserIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Users' }],
            permissions: [UserPermission.READ_USERS],
        },
    },
];
